import { render, staticRenderFns } from "./LevelSection.vue?vue&type=template&id=25e88b85&scoped=true"
import script from "./LevelSection.vue?vue&type=script&lang=js"
export * from "./LevelSection.vue?vue&type=script&lang=js"
import style0 from "./LevelSection.vue?vue&type=style&index=0&id=25e88b85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e88b85",
  null
  
)

export default component.exports